// AI SDR Module Index
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./Dashboard";
import CampaignBuilder from "./CampaignBuilder";
import Campaigns from "./Campaigns";
import Leads from "./Leads";
import Personas from "./Personas";
import Settings from "./Settings";
import Sidebar from "./components/Sidebar";
import LeadSelector from "./components/LeadSelector";
import PersonaSelector from "./components/PersonaSelector";
import CampaignDetails from "./components/CampaignDetails";
import SubjectLines from "./components/SubjectLines";
import EmailPreview from "./components/EmailPreview";
import SharedCampaignsList from "./components/SharedCampaignsList";
import CampaignViewer from "./components/CampaignViewer";
import TeamSettings from "./components/TeamSettings";
import CreateTeam from "./components/CreateTeam";
import Companies from "./Companies";

// Emergency direct dashboard with dummy data - no longer needed as we're using redirects
const DirectDummyDashboard = () => {
  console.log(
    "DirectDummyDashboard rendering - DEPRECATED - Use direct Dashboard component"
  );
  return <Dashboard forceDummy={true} />;
};

export {
  Dashboard,
  DirectDummyDashboard, // Export the direct dashboard component
  CampaignBuilder,
  Campaigns,
  Leads,
  Personas,
  Settings,
  Sidebar,
  LeadSelector,
  PersonaSelector,
  CampaignDetails,
  SubjectLines,
  EmailPreview,
  SharedCampaignsList,
  CampaignViewer,
  TeamSettings,
  CreateTeam,
  Companies,
};

// Main AiSdr component with internal routing
const AiSdr = () => {
  console.log("AiSdr component rendering");
  return (
    <div className="flex h-screen">
      <Sidebar />
      <div className="h-screen w-full overflow-auto bg-gray-50 pb-6">
        <Routes>
          <Route path="/dashboard" element={<Dashboard forceDummy={true} />} />
          <Route
            path="/campaign-manager"
            element={<Dashboard forceDummy={true} />}
          />
          <Route path="/campaign-builder" element={<CampaignBuilder />} />
          <Route path="/campaigns" element={<Campaigns />} />
          <Route path="/leads" element={<Leads />} />
          <Route path="/personas" element={<Personas />} />
          <Route path="/companies" element={<Companies />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/" element={<Navigate replace to="/dashboard" />} />
          <Route path="*" element={<Navigate replace to="/dashboard" />} />
        </Routes>
      </div>
    </div>
  );
};

// Export routes configuration for use in main App.js
export const aiSdrRoutes = {
  path: "/ai-sdr/*",
  element: <AiSdr />,
};

export default AiSdr;
